import { render, staticRenderFns } from "./BottomLogo.vue?vue&type=template&id=51acd6ac&scoped=true&"
import script from "./BottomLogo.vue?vue&type=script&lang=js&"
export * from "./BottomLogo.vue?vue&type=script&lang=js&"
import style0 from "./BottomLogo.vue?vue&type=style&index=0&id=51acd6ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51acd6ac",
  null
  
)

export default component.exports